const enum CouponActionType {
  SET_COUPON_STATUS = 'SET_COUPON_STATUS',
  SET_SHOW_COUPON_SUCCESS = 'SET_SHOW_COUPON_SUCCESS',
}

export { CouponActionType };
